const colors = {
  white: '#ffffff',
  gray100: '#f8f9fa',
  gray200: '#eeeeee',
  gray300: '#dddddd',
  /**
   * add this color to match placeholder color
   * set for credit card input
   */
  gray500: '#B4B8BE',
  gray600: '#777777',
  gray800: '#343A40',
  blue: '#1987d8',
  red: '#EA5362',
};

export { colors };
